module.exports = __webpack_public_path__ + "img/reset-image.e7409731.png";